<template>
    <div v-if="errorMessage"
         class="parametric-limit">
        <IconAlert />
        <span v-html="errorMessage" />
    </div>
</template>

<script>
import {mapGetters} from 'vuex';
import IconAlert from '@/components/Icons/AlertRed';

export default {
    name: 'ParametricLimit',

    components: {
        IconAlert
    },

    computed: {
        ...mapGetters({
            flats: 'parametric/GET_PRINT_FLATS' // массив помещений для печати
        }),

        /**
         * Сообщении ошибки
         * @return {string}
         */
        errorMessage() {
            const limitError = this.flats?.length > 10;

            if (!limitError) {
                return '';
            }

            return 'Ошибка! Вы не можете добавлять более 10 планировок';
        }
    }
};
</script>

<style lang="scss">
@import "ParametricLimit";
</style>
